(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wal-daily-find"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-wal-daily-find]';

  const init = (root) => {
    if (!root || root.dataset.dailyReady === 'true') return;
    root.dataset.dailyReady = 'true';

    const button = root.querySelector('[data-daily-reveal]');
    const content = root.querySelector('[data-daily-content]');
    const countdown = root.querySelector('[data-daily-countdown]');
    const rawHour = Number.parseInt(root.dataset.dropHour || '19', 10);
    const dropHour = Number.isFinite(rawHour) ? Math.min(23, Math.max(0, rawHour)) : 19;
    let activeCycle = '';

    const cycleKey = (now) => {
      const stamp = new Date(now);
      if (stamp.getHours() < dropHour) stamp.setDate(stamp.getDate() - 1);
      return [stamp.getFullYear(), String(stamp.getMonth() + 1).padStart(2, '0'), String(stamp.getDate()).padStart(2, '0')].join('-');
    };

    const storageKey = (cycle) => 'worthalook-daily-find:' + cycle;

    const setRevealed = (revealed) => {
      root.classList.toggle('is-revealed', revealed);
      if (button) button.setAttribute('aria-expanded', revealed ? 'true' : 'false');
      if (content) content.setAttribute('aria-hidden', revealed ? 'false' : 'true');
    };

    const readSavedState = (cycle) => {
      try {
        return window.localStorage.getItem(storageKey(cycle)) === 'revealed';
      } catch (error) {
        return false;
      }
    };

    const saveState = (cycle) => {
      try {
        window.localStorage.setItem(storageKey(cycle), 'revealed');
      } catch (error) {
      }
    };

    const resetForCycle = (now) => {
      activeCycle = cycleKey(now);
      setRevealed(readSavedState(activeCycle));
    };

    if (button) {
      button.addEventListener('click', () => {
        setRevealed(true);
        saveState(activeCycle || cycleKey(new Date()));
      });
    }

    const tick = () => {
      const now = new Date();
      const newCycle = cycleKey(now);

      if (newCycle !== activeCycle) {
        resetForCycle(now);
      }

      if (!countdown) return;

      const next = new Date(now);
      next.setHours(dropHour, 0, 0, 0);
      if (now >= next) next.setDate(next.getDate() + 1);

      const remaining = Math.max(0, next.getTime() - now.getTime());
      const hours = Math.floor(remaining / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      countdown.textContent = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
    };

    resetForCycle(new Date());
    tick();
    window.setInterval(tick, 1000);
  };

  document.querySelectorAll(selector).forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches && event.target.matches(selector)) init(event.target);
    if (event.target.querySelector) event.target.querySelectorAll(selector).forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
